var symphony = symphony || {};

;(function() {

	symphony.checkHeroExistence = function() {



	};


})();